// The one place a currency or a market is described. Every currency and region
// lookup map in the app derives from these two tables, so adding either is a
// single edit here rather than one per map.

export type TCurrency = {
  /** What the payment APIs send in place of the ISO code. */
  symbol: string;
  /**
   * Minor units per major unit as the payment APIs send them — not the ISO 4217
   * exponent. Left off until confirmed against a live response, so that
   * `resolveMinorUnits` falls back to `DEFAULT_MINOR_UNITS` rather than guessing.
   */
  minorUnits?: number;
};

export const CURRENCIES = {
  USD: { symbol: "$", minorUnits: 100 },
  INR: { symbol: "₹", minorUnits: 1 },
  JPY: { symbol: "¥" },
  EUR: { symbol: "€" },
  BRL: { symbol: "R$" },
} as const satisfies Record<string, TCurrency>;

export type TCurrencyCode = keyof typeof CURRENCIES;

export type TMarket = {
  /** ISO 3166-1 alpha-2 codes served this market's pricing and copy. */
  countries: readonly string[];
  currency: TCurrencyCode;
};

// A market has its own content region, localised pricing and currency. The key
// is the region id — `CONTENT_REGION` and `TContentRegion` are derived from it.
export const MARKETS = {
  IN: { countries: ["IN"], currency: "INR" },
} as const satisfies Record<string, TMarket>;

export type TMarketRegion = keyof typeof MARKETS;

export const MARKET_REGIONS = Object.keys(MARKETS) as TMarketRegion[];
